<template>
  <div class="videos">
    <Hero
      class="hero"
      heading="Videos"
    />
    <TextBlock title="Brand videos">
      <p>
        These videos are meant to be seen! Just keep
        in mind that we rather not send big files to our
        customers when we don't have to, since we talk a
        lot about the environmental impact of data transfer.<br/>
        Show it, don't send it!
      </p>
    </TextBlock>
    <div class="surround-all-containers">
      <div class="video-container">
        <img src="/images/video/creative-platform.png" />
        <p @click="download('https://seenthis-brand.s3.amazonaws.com/download/video/creative-platform.mp4.zip')">Creative Platform<img src="/icons/download-arrow.svg" /></p>
      </div>
      <div class="video-container">
        <img src="/images/video/creative-platform-square.png" />
        <p @click="download('https://seenthis-brand.s3.amazonaws.com/download/video/creative-platform-square.mp4.zip')">Creative Platform (square)<img src="/icons/download-arrow.svg" /></p>
      </div>
      <div class="video-container">
        <img src="/images/video/seenthis-explained.jpg" />
        <p @click="download('https://seenthis-brand.s3.amazonaws.com/download/video/seenthis-explainer.mp4.zip')">SeenThis Explainer<img src="/icons/download-arrow.svg" /></p>
      </div>
      <div class="video-container">
        <img src="/images/video/saturnus-dark.jpg" />
        <p @click="download('https://seenthis-brand.s3.amazonaws.com/download/video/saturnus-dark.mov.zip')">Saturnus Dark<img src="/icons/download-arrow.svg" /></p>
      </div>
      <div class="video-container">
        <img src="/images/video/timetravel-dark.jpg" />
        <p @click="download('https://seenthis-brand.s3.amazonaws.com/download/video/timetravel-dark.mp4.zip')">Timetravel Dark<img src="/icons/download-arrow.svg" /></p>
      </div>
      <div class="video-container">
        <img src="/images/video/timetravel-light.jpg" />
        <p @click="download('https://seenthis-brand.s3.amazonaws.com/download/video/timetravel-light.mp4.zip')">Timetravel Light<img src="/icons/download-arrow.svg" /></p>
      </div>
      <div class="video-container">
        <img src="/images/video/saturnus-light.jpg" />
        <p @click="download('https://seenthis-brand.s3.amazonaws.com/download/video/saturnus-light.mp4.zip')">Saturnus Light<img src="/icons/download-arrow.svg" /></p>
      </div>
    </div>
    <ViLinks />
  </div>
</template>
<script>
import Hero from '../components/hero.vue';
import TextBlock from '../components/text-block.vue';
import ViLinks from '../components/visual-id-links.vue';

export default {
  name: 'Videos',
  components: {
    Hero,
    TextBlock,
    ViLinks,
  },
  methods: {
    download(url) {
      window.open(url);
    },
  },
};
</script>


<style lang="stylus" scoped>
@require '../style/colors'

  .surround-all-containers
    display: flex
    flex-wrap: wrap
    justify-content: center
    gap: 2rem
    max-width: 95rem
    margin: 0 auto 5rem auto
    padding: 0 2rem

    .video-container
      img
        height: 15rem

      p
        margin-top: 0.5rem
        font-size: 1.6rem
        font-weight: 300
        color: $primary-color
        cursor: pointer

        img
          height: 1.5rem
          margin-left: 0.8rem

</style>
